import React, { useMemo } from "react";
import ArrowIcon from "assets/images/images_new/dropdown-icon.svg";

export default function Pagination({
  activePage = 1,
  itemsCountPerPage = 10,
  totalItemsCount = 0,
  pageRangeDisplayed = 5,
  onChange,
  innerClass = "",
  activeClass = "",
  itemClass = "",
  linkClass = "",
}) {
  const totalPages = Math.ceil(totalItemsCount / itemsCountPerPage);

  const pages = useMemo(() => {
    const half = Math.floor(pageRangeDisplayed / 2);
    let start = Math.max(activePage - half, 1);
    let end = start + pageRangeDisplayed - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(end - pageRangeDisplayed + 1, 1);
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }, [activePage, pageRangeDisplayed, totalPages]);

  const handlePrev = () => {
    if (activePage > 1) {
      onChange(activePage - 1);
    }
  };

  const handleNext = () => {
    if (activePage < totalPages) {
      onChange(activePage + 1);
    }
  };

  return (
    <div className="dashboard-pagination m-0">
      <ul className={innerClass}>
        {/* PREVIOUS */}
        <li>
          <button
            type="button"
            className={`${itemClass} prev-arrow ${
              activePage === 1 ? "disabled" : ""
            }`}
            onClick={handlePrev}
            disabled={activePage === 1}
          >
            <img src={ArrowIcon} alt="Prev" />
          </button>
        </li>

        {/* PAGE NUMBERS */}
        {pages.map((p) => (
          <li key={p}>
            <button
              type="button"
              className={`${itemClass} ${p === activePage ? activeClass : ""}`}
              onClick={() => onChange(p)}
            >
              {p}
            </button>
          </li>
        ))}

        {/* NEXT */}
        <li>
          <button
            type="button"
            className={`${itemClass} next-arrow ${
              activePage === totalPages ? "disabled" : ""
            }`}
            onClick={handleNext}
            disabled={activePage === totalPages}
          >
            <img src={ArrowIcon} alt="Next" />
          </button>
        </li>
      </ul>

      </div>
  );
}
